/*LIBRARY*/
import { Component, createRef } from "react";
import { connect } from "react-redux";

/*COMPONENT*/

/*REDUX*/
import {
  searchLayersOnly,
  searchLayersOnlyV2,
  searchLayersOnlyCount,
  downloadLayer,
  clearSearchLayer,
  loadMoreSearchLayersOnly,
  loadMoreSearchLayersOnlyV2,
} from "../../App/actions/layerActions";
import { attachLayer } from "../../App/actions/layerNewActions";
import {
  get_data_premium_count,
  search_data_premium,
  get_data_premium_by_category_id,
  load_more_search_data_premium,
  empty_data_premium_by_category_id,
  get_data_premium_by_category_id_count,
  reset_get_data_premium_by_category_id_count,
  set_loading,
} from "../../App/actions/moneyActions";
import { clone_layer } from "../../App/actions/propertiesActions";
import { is_has_license_basic_or_license_sharing } from "../../App/actions/filter_license";

/*PICTURE*/
import pic_static from "../../Assets/svg/profile_pic_comment.svg";

/*FUNCTION*/

/*DATA*/
import dict from "../../Data/dict.json";
import { ErrorContext } from "../../Debug/ErrorHandler/ErrorContext";
import { set_value_user } from "../../App/actions/authActions";

/*CONST*/
const WAIT_INTERVAL = 1000;
const ENTER_KEY = 13;

const sort_item = (array, lang, isFromSmall) => {
  if (lang) {
    if (isFromSmall) {
      function compare(a, b) {
        if (a?._id?.[lang] < b?._id?.[lang]) return -1;
        if (a?._id?.[lang] > b?._id?.[lang]) return 1;
        return 0;
      }
      return array.sort(compare);
    } else {
      function compare(a, b) {
        if (a?._id?.[lang] < b?._id?.[lang]) return 1;
        if (a?._id?.[lang] > b?._id?.[lang]) return -1;
        return 0;
      }
      return array.sort(compare);
    }
  } else {
    if (isFromSmall) {
      function compare(a, b) {
        if (a < b) return -1;
        if (a > b) return 1;
        return 0;
      }
      return array.sort(compare);
    } else {
      function compare(a, b) {
        if (a < b) return 1;
        if (a > b) return -1;
        return 0;
      }
      return array.sort(compare);
    }
  }
};

class SEARCH_LAYER extends Component {
  state = {
    search_params: "",
    category_id: "",
    geo_layer: {},
    mode: "premium", //private | premium
    layers_attach_id: [],
    layers_import_id: [],
    modal_block: false,
    data_skip: {
      private: 0,
      premium: 0,
    },
    // geo_layer_list: [],
    isTyping: false,
    geo_layer_list_scroll_position: 0,
  };

  // Error handling context
  static contextType = ErrorContext;

  containerRef = createRef();

  componentDidMount() {
    const { handleError } = this.context;

    handleError(() => {
      this.timer = null;
      const list_id = this.props.layer.geo_layer_list.map((l) => l._id);
      this.setState({ layers_attach_id: list_id });
      this.props.get_data_premium_count();
    })();
  }

  componentWillUnmount() {
    const { handleError } = this.context;

    handleError(() => {
      this.setState({
        search_params: "",
        geo_layer: {},
        mode: "private",
        data_skip: {
          private: 0,
          premium: 0,
        },
      });
    })();
  }

  componentDidUpdate() {
    const { handleError } = this.context;

    handleError(() => {
      this.containerRef.current.scrollTop =
        this.state.geo_layer_list_scroll_position;
    })();
  }

  on_get_data_premium_by_category_id = (category_id) => {
    const { handleError } = this.context;

    handleError(() => {
      const { search_params } = this.state;

      this.setState({
        geo_layer_list_scroll_position: 0,
      });
      let new_category_id;
      if (category_id === this.state.category_id) {
        new_category_id = "";
        this.setState({
          category_id: "",
          geo_layer_list_scroll_position: 0,
          data_skip: { premium: 20 },
        });
        if (!search_params) {
          this.props.empty_data_premium_by_category_id();
          this.setState({
            category_id: new_category_id,
            data_skip: {
              premium: 20,
            },
            geo_layer_list_scroll_position: 0,
          });
          return;
        }
      } else {
        new_category_id = category_id;
        this.setState({
          category_id,
          data_skip: {
            premium: 20,
          },
        });
      }
      this.props.get_data_premium_by_category_id(
        new_category_id,
        search_params
      );
      this.props.get_data_premium_by_category_id_count(
        search_params,
        new_category_id
      );
    })();
  };

  toggleBlock = () => {
    const { handleError } = this.context;
    handleError(() => {
      this.setState({ modal_block: !this.state.modal_block });
    })();
  };

  handleMode = (mode) => {
    const { handleError } = this.context;
    handleError(() => {
      this.setState({
        mode,
        search_params: "",
        // geo_layer_list: []
      });
      this.props.clearSearchLayer();
    })();
  };

  handlePushProject = (geo_layer) => {
    const { handleError } = this.context;
    handleError(() => {
      const { mode } = this.state;

      if (
        this.props.is_has_license_basic_or_license_sharing() ||
        mode !== "premium"
      ) {
        //jika lolos maka jalankan fungsi import data
        let { layers_attach_id } = this.state;
        layers_attach_id?.push(geo_layer._id);
        this.setState({ geo_layer, layers_attach_id }, () => {
          const { geo_project } = this.props.project;
          const geo_project_id = geo_project?._id;
          const body = {
            geo_project_id,
            geo_layer,
          };
          this.props.attachLayer(body);
        });
      } else {
        //jika tidak lolos maka toggle penawaran pricing
        this.props.block_license_with_handler();
      }
    })();
  };

  handleDownload = (geo_layer) => {
    const { handleError } = this.context;

    handleError(() => {
      const { mode } = this.state;

      if (
        this.props.is_has_license_basic_or_license_sharing() ||
        mode !== "premium"
      ) {
        //jika lolos maka jalankan fungsi import data
        let { layers_import_id } = this.state;
        layers_import_id?.push(geo_layer._id);
        const geo_project_link = this?.props?.project?.geo_project?.link;
        this.setState({ geo_layer, layers_import_id }, () => {
          const { geo_project } = this.props.project;
          const { user } = this.props.auth;
          const geo_layer_id = geo_layer?._id;
          const body = {
            geo_layer_id: geo_layer_id,
            geo_project_id: geo_project?._id,
            user_id: user?._id,
            new_name: geo_layer?.name,
          };

          this.props.clone_layer(body, geo_project_link);
          // this.props.downloadLayer(body);
        });
      } else {
        //jika tidak lolos maka toggle penawaran pricing
        this.props.set_value_user("modal_block_sini_ai_sini_data", true)
      }
    })();
  };

  handleChange(e) {
    const { handleError } = this.context;

    handleError(() => {
      if (this.props.layer.search_result_list.geo_layer_list.length > 0) {
        this.props.clearSearchLayer();
      }

      const value = e.target.value;
      const name = e.target.name;
      clearTimeout(this.timer);
      this.setState({
        [name]: value,
        isTyping: true,
        data_skip: {
          private: 0,
          premium: 0,
        },
        // category_id: "",
      });
      this.timer = setTimeout(this.triggerChange.bind(this), WAIT_INTERVAL);
    })();
  }

  handleKeyDown(e) {
    const { handleError } = this.context;
    handleError(() => {
      if (e.keyCode === ENTER_KEY) {
        this.triggerChange.bind(this);
      }
    })();
  }

  triggerChange() {
    const { handleError } = this.context;

    handleError(() => {
      const { search_params, mode, category_id } = this.state;

      if (search_params) {
        if (mode === "private") {
          this.props.searchLayersOnlyV2(search_params);
          this.props.searchLayersOnlyCount(search_params);
          this.setState({
            data_skip: {
              ...this.state.data_skip,
              private: this.state.data_skip.private + 20,
            },
            isTyping: false,
            geo_layer_list_scroll_position: 0,
          });
        } else if (mode === "premium") {
          this.props.search_data_premium(search_params, category_id);
          this.props.get_data_premium_by_category_id_count(
            search_params,
            category_id
          );
          this.setState({
            data_skip: {
              ...this.state.data_skip,
              premium: this.state.data_skip.premium + 20,
            },
            isTyping: false,
            geo_layer_list_scroll_position: 0,
          });
        }
      } else {
        if (mode === "premium") {
          if (!category_id) {
            // jika tidak ada search_params dan category_id maka reset data untuk geo layer list count
            this.props.reset_get_data_premium_by_category_id_count();
          } else {
            // jika tidak ada search_params tetapi ada category_id maka lakukan pencarian berdasarkan category_id saja
            this.props.search_data_premium("", category_id);
            this.props.get_data_premium_by_category_id_count("", category_id);
            this.setState({
              data_skip: {
                ...this.state.data_skip,
                premium: this.state.data_skip.premium + 20,
              },
              isTyping: false,
              geo_layer_list_scroll_position: 0,
            });
          }
        }
      }
    })();
  }

  handleLoadMore = () => {
    const { handleError } = this.context;
    handleError(() => {
      const { search_params, mode, data_skip, category_id } = this.state;

      // Save scroll position before load more
      const scrollPosition =
        this.containerRef.current.scrollTop +
        this.containerRef.current.clientHeight -
        30;

      // Helper function to update state and call the appropriate loadMore function
      const loadMoreData = (loadFunction, skipKey) => {
        const currentSkip = data_skip[skipKey];
        if (currentSkip >= 20) {
          if (mode === "premium") {
            loadFunction(search_params || "", category_id, currentSkip);
          } else if (mode === "private") {
            loadFunction(search_params, currentSkip);
          }

          this.setState({
            data_skip: {
              ...data_skip,
              [skipKey]: currentSkip + 20,
            },
            geo_layer_list_scroll_position: scrollPosition,
          });
        }
      };

      // Determine which loadMore function to call based on the mode
      switch (mode) {
        case "private":
          loadMoreData(this.props.loadMoreSearchLayersOnlyV2, "private");
          break;
        case "premium":
          loadMoreData(this.props.load_more_search_data_premium, "premium");
          break;
        default:
          break;
      }
    })();
  };

  render() {
    //local storage
    const language = localStorage?.language || this.props.auth.language;

    //local state
    const {
      search_params,
      mode,
      layers_attach_id,
      layers_import_id,
      category_id,
      // modal_error_free,
    } = this.state;
    const geo_layer_state = this.state.geo_layer;

    //global props
    const { loading_status, loading_item } = this.props.layer;
    const {
      geo_layer_list,
      geo_layer_list_count,
      // geo_layer_list_load_more_count,
    } = this.props.layer.search_result_list;
    let { data_premium_count } = this.props.blog;

    data_premium_count = sort_item(data_premium_count, language, true);

    //content
    let result_content = [];
    let loading_content = null;

    if (loading_status && loading_item === "search_layer") {
      result_content = (
        <div className="container_grey">{dict["Searching"][language]}...</div>
      );
    } else if (
      // !loading_status &&
      // loading_item !== "search_layer" &&
      geo_layer_list?.length === 0 &&
      !geo_layer_list_count
    ) {
      result_content = !this.state.isTyping && !loading_status && (
        <div className="container_grey">{dict["No result"][language]}</div>
      );
    } else if (
      !loading_status &&
      loading_item !== "search_layer" &&
      geo_layer_list?.length > 0 &&
      geo_layer_list_count
    ) {
      result_content = (
        <div>
          {geo_layer_list?.map((geo_layer, idx) => {
            const { _id, name, geo_project } = geo_layer;
            const description = geo_layer?.description;
            const geo_project_name = geo_project?.name;
            const full_name = geo_layer?.user?.full_name
              ? geo_layer?.user?.full_name
              : geo_layer?.user?.name;
            const profile_picture = geo_layer?.user?.profile_picture
              ? geo_layer?.user?.profile_picture
              : {};
            let button_attach = null;
            let button_download = null;
            if (
              loading_status &&
              loading_item === "push_project_attach" &&
              geo_layer_state?._id === _id
            ) {
              button_attach = (
                <div className="button background_black">
                  {dict["Importing"][language]}...
                </div>
              );
            } else if (
              loading_status &&
              loading_item === "download_layer" &&
              geo_layer_state?._id === _id
            ) {
              button_download = (
                <button className="button background_black">
                  {dict["Downloading"][language]}...
                </button>
              );
            } else {
              button_attach = (
                <main style={{ marginBottom: "10px" }}>
                  <button
                    onClick={this.handlePushProject.bind(this, geo_layer)}
                    className="button background_black"
                    data-mapid={`clickAttach-${idx}`}
                  >
                    {dict["Attach"][language]}
                  </button>
                  <section className="text_inferior">
                    {dict["Attach layers"][language]}{" "}
                    <b>{dict["NOT EDITABLE"][language]}</b>
                  </section>
                </main>
              );
              button_download = (
                <main>
                  <button
                    onClick={this.handleDownload.bind(this, geo_layer)}
                    className="button background_black"
                    data-mapid={`clickImport-${idx}`}
                  >
                    {dict["Import"][language]}
                  </button>
                  <section className="text_inferior">
                    {dict["Import layers"][language]}{" "}
                    <b>{dict["EDITABLE"][language]}</b>
                  </section>
                </main>
              );
              if (layers_attach_id?.includes(_id)) {
                button_attach = (
                  <main style={{ marginBottom: "10px" }}>
                    <button className="button background_black" id="grey">
                      {dict["Attached"][language]}
                    </button>
                    <section className="text_inferior">
                      {dict["Attach layers"][language]}{" "}
                      <b>{dict["NOT EDITABLE"][language]}</b>
                    </section>
                  </main>
                );
              }
              if (layers_import_id?.includes(_id)) {
                button_download = (
                  <main>
                    <button className="button background_black" id="grey">
                      {dict["Imported"][language]}
                    </button>
                    <section className="text_inferior">
                      {dict["Import layers"][language]}{" "}
                      <b>{dict["EDITABLE"][language]}</b>
                    </section>
                  </main>
                );
              }
            }
            return (
              <main
                key={idx}
                className="container background_white margin_bottom outline_grey"
              >
                <main className="two_container_auto">
                  <section style={{ textAlign: "left" }}>
                    <div className="text_bold">
                      {idx + 1}
                      {". "}
                      {name}
                    </div>
                    {description && (
                      <div className="text_inferior">{description}</div>
                    )}
                    <div className="text_inferior">
                      {dict["Project"][language]}: {geo_project_name}
                    </div>
                    <div
                      alt={_id}
                      className={`photo_${_id} marginTop_5`}
                      samesite="None"
                      secure="true"
                    />
                    <p
                      style={{
                        display: "inline-block",
                        verticalAlign: "middle",
                        marginLeft: "10px",
                        fontSize: "12px",
                      }}
                      className="marginTop_5"
                    >
                      {full_name}
                    </p>
                    <style>
                      {`.photo_${_id}{
                      background: url(${profile_picture && profile_picture?.url_compressed
                          ? profile_picture?.url_compressed
                          : profile_picture &&
                            profile_picture?.url &&
                            profile_picture?.url !==
                            "https://s3-us-west-2.amazonaws.com/geomapid-assets/astronot.png" &&
                            profile_picture?.url !== "-" &&
                            profile_picture?.url !== "default"
                            ? profile_picture?.url
                            : pic_static
                        }) no-repeat center center/ cover;
                      background-color: #c1c1c1;
                      height:40px;
                      width:40px;
                      border-radius: 50%;
                      border: 2px solid #2196f3;
                      display: inline-block;
                      align: center;
                      vertical-align: middle;
        }`}
                    </style>
                  </section>
                  <section style={{ textAlign: "right" }}>
                    {button_attach}
                    {button_download}
                  </section>
                </main>
              </main>
            );
          })}
        </div>
      );
    }

    const loadMoreButton = (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        onClick={this.handleLoadMore}
      >
        <button className="button background_black">Load More</button>
      </div>
    );

    return (
      <main style={{ height: "100%", overflow: "auto" }}>
        <main>
          <section className="text_header">
            {dict["Search Layer"][language]}{" "}
            {search_params &&
              !(loading_status && loading_item === "search_layer") &&
              `(${dict["Result"][language]}: ${geo_layer_list?.length} ${dict["from"][language]
              } ${geo_layer_list_count || 0} data)`}
          </section>

          <section className="text_medium sub_color margin_bottom">
            {
              dict[
              "Search layer from all your project or public layer then import it to this project."
              ][language]
            }
          </section>

          <section className="text_center margin_bottom_extra">
            <button
              onClick={this.handleMode.bind(this, "private")}
              className={`button noselect use_margin outline_shadow_soft ${mode === "private" ? "background_black" : "button_white"
                }`}
              data-mapid="clickDataKamu"
            >
              {dict["Your Layers"][language]}
            </button>
            <button
              onClick={this.handleMode.bind(this, "premium")}
              className={`button noselect use_margin outline_shadow_soft ${mode === "premium" ? "background_black" : "button_white"
                }`}
              data-mapid="clickDataPremium"
            >
              Data Premium
            </button>
          </section>

          <input
            className="input_square margin_bottom"
            type="text"
            placeholder={dict["Search layers"][language]}
            autoComplete="off"
            name="search_params"
            value={search_params}
            onChange={this.handleChange.bind(this)}
            onKeyDown={this.handleKeyDown.bind(this)}
            data-mapid="searchDataKamu"
          />

          {mode === "premium" && (
            <section className="margin_bottom_extra">
              <h1 className="text_bold margin_bottom">Etalase data</h1>
              {data_premium_count?.map((item, idx) => {
                let name;
                if (item?._id?.idn) {
                  if (language === "ina") {
                    name = item?._id?.idn;
                  } else {
                    name = item?._id?.eng;
                  }
                } else {
                  name = "Other";
                }
                return (
                  <section
                    key={idx}
                    className={`margin_right margin_bottom container outline_shadow_soft container_small ${category_id === item?._id?._id
                        ? "bg_blue text_white"
                        : "button_white"
                      }`}
                    onClick={this.on_get_data_premium_by_category_id.bind(
                      this,
                      item?._id?._id
                    )}
                    data-mapid={`clickPremium-${idx}`}
                  >
                    <p className="text_bold">{name}</p>
                    <p className="text_medium">{item?.sum}</p>
                  </section>
                );
              })}
            </section>
          )}

          <section
            ref={this.containerRef}
            style={{ height: "calc(( 85vh - 130px ))", overflowY: "auto" }}
          >
            {(search_params || category_id) && result_content}
            {loading_content}
            {geo_layer_list?.length &&
              geo_layer_list?.length < geo_layer_list_count &&
              !loading_status &&
              loading_item !== "search_layer"
              ? loadMoreButton
              : ""}
          </section>
        </main>
      </main>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  layer: state.layer,
  project: state.project,
  payment: state.payment,
  blog: state.blog,
  license_reducer: state.license_reducer,
});

export default connect(mapStateToProps, {
  clone_layer,
  searchLayersOnly,
  searchLayersOnlyV2,
  searchLayersOnlyCount,
  downloadLayer,
  clearSearchLayer,
  attachLayer,
  loadMoreSearchLayersOnly,
  loadMoreSearchLayersOnlyV2,
  get_data_premium_count,
  search_data_premium,
  get_data_premium_by_category_id,
  load_more_search_data_premium,
  empty_data_premium_by_category_id,
  get_data_premium_by_category_id_count,
  reset_get_data_premium_by_category_id_count,
  set_loading,
  is_has_license_basic_or_license_sharing,
  set_value_user
})(SEARCH_LAYER);
